import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { extender } from "../../backend/class-extender";
import { Category } from "../category";
import { Position } from "../position";
import { SubCategoryFieldConfig } from "../sub-category-field-config";
import { SubCategoryImage } from "../sub-category-image";
import { SubCategoryEntityConfig } from "./config";
import { SubCategoryFilters } from "./filters";
import { SubCategoryMethods } from "./methods";

@HyperEntity("sub-category", SubCategoryEntityConfig)
export class SubCategory extends extender(
  SubCategoryFilters,
  SubCategoryMethods,
) {
  @Fields.id()
  id = "";

  @Fields.string()
  name = "";

  @Fields.string({ dbName: "category" })
  categoryId = "";

  @Relations.toOne(() => Category, { field: "categoryId" })
  category?: Category;

  @Fields.string({ dbName: "position" })
  positionId = "";

  @Relations.toOne(() => Position, { field: "positionId" })
  position?: Position;

  @Fields.boolean({ dbName: "is_remote", caption: "מרחוק" })
  isRemote = false;

  @Fields.boolean({ dbName: "is_short_form", caption: "טופס קצר" })
  isShortForm = false;

  @Fields.boolean({ dbName: "is_link_only", caption: "רק בקישור" })
  isLinkOnly = false;

  @Fields.integer({ dbName: "sort_order" })
  sortOrder = 10000;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();

  @Relations.toMany(() => SubCategoryFieldConfig, "subCategoryId")
  fieldConfigs: SubCategoryFieldConfig[] = [];

  @Relations.toMany(() => SubCategoryImage, "subCategoryId")
  images: SubCategoryImage[] = [];
}
